import { render } from "./DefaultLayout.vue?vue&type=template&id=49605f3f"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=49605f3f&lang=css"
script.render = render

export default script